import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useModal } from "../../contexts/ModalContext";

export default function DynamicFaq({ data, aiData, extraClass = "" }) {
  const { openQueryModal } = useModal();
  const [activeKey, setActiveKey] = useState(null);
  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  return (
    <section className={`healthcare-faq ${extraClass}`}>
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="faq-inner">
              {data?.title && <h4 className="heading">{data.title}</h4>}
              {data?.description && <p>{data.description}</p>}
              <div className="faq-btn">
                <Link className="default-btn" onClick={openQueryModal}>
                  <span>{data.buttonText}</span>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div className="faq-content">
              <Accordion activeKey={activeKey}>
                {aiData?.faqs && aiData?.faqs?.map((item, index) => (
                  <Accordion.Item eventKey={index.toString()} key={index}>
                    <Accordion.Header onClick={() => handleToggle(index.toString())} className="accor-btn-box">
                      <span className="accor-text-head heading">   {item?.question} </span>
                      <span className="arrow">   {activeKey === index.toString() ? "−" : "+"}    </span>
                    </Accordion.Header>
                    <Accordion.Body> <p>{item?.answer}</p>  </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}